export enum PlatformTypeEnum {
  COTTON = 'COTTON',
  GRAIN = 'GRAIN',
}
